<template>
  <div class="header">
    <div class="shadow" @click="toggleMenu()" :class="{ 'shadow--visible': menuVisibitity }"></div>

    <div class="header--container">
      <div class="title">
        <img class="title--logo" src="../assets/logo.png" />
        <h1 class="title--text">LIGA DE AMIGOS E MELHORAMENTOS DA FREGUESIA DE ALCAFOZES</h1>
        <div class="toggle-menu" @click="toggleMenu()"><img src="../assets/menu.svg" /></div>
      </div>

      <div class="menu" :class="{ 'menu--visible': menuVisibitity }">
        <router-link to="/">
          <div class="menu--item">Início</div>
        </router-link>
        <router-link to="/corpos-sociais">
          <div class="menu--item">Corpos Sociais</div>
        </router-link>
        <router-link to="/contas-lamfa">
          <div class="menu--item">Contas da LAMFA</div>
        </router-link>
        <router-link to="/diversos">
          <div class="menu--item">DIVERSOS</div>
        </router-link>
        <router-link to="/alcafozense">
          <div class="menu--item">O Alcafozense</div>
        </router-link>
        <router-link to="/comissoes-festa">
          <div class="menu--item">Comissões de Festa</div>
        </router-link>
        <router-link to="/contas-festa">
          <div class="menu--item">Contas da festa</div>
        </router-link>
        <router-link to="/fotos-videos">
          <div class="menu--item">Fotos / Videos</div>
        </router-link>
        <router-link to="/links">
          <div class="menu--item">Link's</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    menuVisibitity: false
  }),
  methods: {
    toggleMenu() {
      this.menuVisibitity = !this.menuVisibitity;
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  background: var(--color-white);
  width: 100%;

  .shadow {
    display: none;
  }

  .header--container {
    max-width: 1280px;
    margin: 0 auto;
    margin-top: 33px;
    background: #d5d5d5;
    background: linear-gradient(180deg, rgba(255,255,255,1) 0%, #d5d5d5 100%);
    box-shadow: 0 10px 10px rgba(0,0,0,0.1);

    .title {
      display: flex;
      justify-content: center;
      border: 1px solid #d5d5d5;
      border-bottom: 0;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;

      .toggle-menu {
        display: none;
      }
      
      .title--logo {
        position: absolute;
        top: 10px;
        height: 60px;
        border-radius: 25%;
        margin-right: 1072px;
        box-shadow: 0 5px 5px rgba(0,0,0,0.5);
      }

      .title--text {
        color: #586fc6;
        font-size: 1.875rem;
        margin-left: 6rem;
        padding: 4px 0;
      }
    }

    .menu {
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #d5d5d5;
      border-top: 0;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;

      .menu--item {
        background: #3557d8;
        width: fit-content;
        padding: 0.7rem 0.5rem;
        border: 1px solid #5280e9;
        text-transform: uppercase;
        font-weight: bold;
        color: #fff;

        &:hover {
          background: #586fc6;
        }
      }

      a.router-link-exact-active > .menu--item {
        background: var(--color-mid-blue);
      }
    }
  }
}

@media (max-width: 900px) {
  .header {
    .shadow {
      position: absolute;
      display: block;
      visibility: hidden;
      width: 100vw;
      height: 100vh;
      background: rgba(0,0,0,0.5);
      z-index: 90;
      opacity: 0;
      transition: ease-in-out visibility 500ms, ease-in-out opacity 500ms;

      &.shadow--visible {
        visibility: visible;
        opacity: 1;
      }
    }

    .header--container {
      margin: 0 auto;

      .title {
        align-items: center;
        padding: 10px 0;

        .toggle-menu {
          display: block;
          padding: 0 20px;
          cursor: pointer;
        }
        
        .title--logo {
          position: static;
          top: 0;
          margin: 0 20px;
        }

        .title--text {
          font-size: 1.6rem;
          margin: 0;
        }
      }

      .menu {
        flex-direction: column;
        justify-content: left;
        position: absolute;
        top: 0;
        background: var(--color-grey);
        height: 100vh;
        right: -202px;
        z-index: 100;
        transition: ease-in-out right 500ms;

        &.menu--visible {
          right: 0;
        }

        .menu--item {
          width: 200px;
          padding: 1.2rem;
        }
      }
    }
  }
}
</style>
